import type {
  IUserSuggestedUpdateDismissUpdateParams,
  IUserSuggestedUpdateDismissUpdateRequest,
  IUserSuggestedUpdateDismissUpdateResponse,
} from '@/app-package';

import axios from 'axios';

const dismissUpdate = async (
  params: IUserSuggestedUpdateDismissUpdateParams,
) => {
  const config: IUserSuggestedUpdateDismissUpdateRequest = {
    url: `suggested_user_update/dismiss_update/${params.suggestedUpdateId}`,
    method: 'post',
  };

  const { data } =
    await axios.request<IUserSuggestedUpdateDismissUpdateResponse>(config);

  return data;
};

export default dismissUpdate;
